import React from 'react'
import './style.css'

export default function Stat() {
  return (
    <div className='Stat'>
        <span>
            <div className='Stat_Con'>
                <h2>80+</h2>
                <p>Projects</p>
            </div>
            <div className='Stat_Con'>
                <h2>25+</h2>
                <p>Global Clients</p>
            </div>
            <div className='Stat_Con'>
                <h2>4 yrs</h2>
                <p>Experience</p>
            </div>
            <div className='Stat_Con'>
                <h2>25+</h2>
                <p>Skills</p>
            </div>
        </span>
    </div>
  )
}
